// src/router.jsx
import { useEffect } from "react";
import { createBrowserRouter, Navigate } from "react-router-dom";
import AdminDashboard from "./admin/pages/AdminDashboard";
import FormDashboard from "./admin/pages/FormDashboard";
import FormPage from "./public/pages/FormPage";
import FormEditor from "./admin/FormEditor/FormEditor.jsx";
import FormPreview from "./admin/pages/FormPreview.jsx";

export const PREFIX = "/regform";

// Create a Redirect component for external redirects
const Redirect = ({ to }) => {
  useEffect(() => {
    window.location.href = to;
  }, [to]);
  return null;
};

export const router = createBrowserRouter(
  [
    {
      path: "/",
      children: [
        {
          path: "",
          element: <Redirect to={`${PREFIX}/admin`} />,
        },
        {
          path: "admin",
          element: <AdminDashboard />,
          children: [
            {
              path: "",
              element: <Navigate to="form" replace />,
            },
            {
              path: "form",
              element: <FormDashboard mode="form" />,
            },
            {
              path: "test",
              element: <FormDashboard mode="test" />,
            },
            {
              path: "draft",
              element: <FormDashboard mode="draft" />,
            },
            {
              path: "form/edit/subforms/:formId",
              element: <FormEditor mode="form" subform={true} />,
            },
            {
              path: "draft/edit/subforms/:formId",
              element: <FormEditor mode="draft" subform={true} />,
            },
            {
              path: "form/edit/:formId",
              element: <FormEditor mode="form" />,
            },
            {
              path: "test/edit/:formId",
              element: <FormEditor mode="test" />,
            },
            {
              path: "draft/edit/:formId",
              element: <FormEditor mode="draft" />,
            },
            {
              path: "form/new",
              element: <FormEditor />,
            },
            {
              path: "form/preview/subforms/:formId",
              element: <FormPreview mode="form" subform={true} />,
            },
            {
              path: "draft/preview/subforms:formId",
              element: <FormPreview mode="draft" subform={true} />,
            },
            {
              path: "form/preview/:formId",
              element: <FormPreview mode="form" />,
            },
            {
              path: "test/preview/:formId",
              element: <FormPreview mode="test" />,
            },
            {
              path: "draft/preview/:formId",
              element: <FormPreview mode="draft" />,
            },
          ],
        },
        {
          path: "test/:formId",
          element: <FormPage mode="test" />,
        },
        {
          path: "form/:formId",
          element: <FormPage mode="form" />,
        },
        {
          path: "draft/:formId",
          element: <FormPage mode="draft" />,
        },
        {
          path: "form",
          element: <FormPage />,
        },
        {
          path: "*",
          element: <Redirect to={`${PREFIX}/invalid-page.html`} />,
        },
      ],
    },
    {
      path: "*",
      element: <Redirect to={`${PREFIX}/invalid-page.html`} />,
    },
  ],
  {
    basename: PREFIX, // Base URL prefix for all routes
  }
);
